module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-panel', {
    attrs: {
      "contextual-style": "primary"
    }
  }, [_c('h1', {
    staticClass: "panel-title",
    slot: "heading"
  }, [_vm._v("\n      User Administration "), _c('button', {
    staticClass: "btn btn-xs btn-info",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.adduser()
      }
    }
  }, [_vm._v("Add User")])]), _vm._v(" "), _c('div', {
    slot: "body"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("E-Mail")]), _vm._v(" "), _c('th', [_vm._v("Roles")]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.$store.state.account.userlist), function(thisuser, userindex) {
    return _c('tr', {
      class: {
        'editable': thisuser.type !== 'global'
      },
      on: {
        "click": function($event) {
          _vm.selectUser(thisuser)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(thisuser.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(thisuser.email))]), _vm._v(" "), _c('td', _vm._l((_vm.$store.state.account.userlist[userindex].roles), function(thisrole) {
      return _c('span', [_c('button', {
        staticClass: "btn btn-xs btn-info"
      }, [_vm._v(_vm._s(thisrole))]), _vm._v(" ")])
    })), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-xs btn-warning"
    }, [_vm._v("Edit")])])])
  }))])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79bd8cb2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/admin/user-list/index.vue
// module id = 232
// module chunks = 1